import cn from 'classnames';
import React from 'react';

import s from './CircularProgress.module.scss';

type Props = React.SVGProps<SVGSVGElement>;

export const CircularProgress = (props: Props): JSX.Element => {
  const { className, ...restProps } = props;

  return (
    <svg
      width={32}
      height={32}
      className={cn(s.loader, className)}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M33 17a16 16 0 1 1-6.4-12.8"
        stroke="url(#loader-gradient)"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="loader-gradient"
          x1="24.2"
          y1="4.6"
          x2="52.6"
          y2="26.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset={1} stopColor="currentColor" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  );
};
